import {MutationCache, QueryCache, QueryClient} from "@tanstack/react-query";
import {createTRPCClient, httpBatchLink} from "@trpc/client";
import {createTRPCOptionsProxy} from "@trpc/tanstack-react-query";
import type {AppRouter} from "@chayka/trpc";
import {env} from "@/lib/env";

const isUnauthorizedError = (error: unknown) => {
  if (!error || typeof error !== "object" || !("data" in error)) return false;

  return (error as {data?: {code?: string}}).data?.code === "UNAUTHORIZED";
};

let queryClient: QueryClient;

export const resetAuthState = () => {
  const authQueries = queryClient.getQueryCache().findAll({
    predicate: ({queryKey}) => {
      const [path] = queryKey;
      return Array.isArray(path) && path[0] === "auth" && path[1] === "me";
    },
  });

  for (const query of authQueries) query.setData(null);
};

const resetClientOnUnauthorized = (error: unknown) => {
  if (isUnauthorizedError(error)) resetAuthState();
};

queryClient = new QueryClient({
  queryCache: new QueryCache({onError: resetClientOnUnauthorized}),
  mutationCache: new MutationCache({onError: resetClientOnUnauthorized}),
});

export {queryClient};

const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${env.VITE_API_URL}/trpc`,
      fetch: (url, options) =>
        fetch(url, {
          ...options,
          credentials: "include",
          cache: "no-store",
        }),
    }),
  ],
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient,
});
